import { formatNumber } from '@progress/kendo-intl';

const generateCircleCharts = (widgetInstance, chartData, selectedPeriod, setSeries, setup, setGridData) => {
  let periodIdField = 'id';

  const _registerGridRecord = (val, periodHash, amount, gridData) => {
    let gridVal = periodHash[val.periodId];
    if (!gridVal) {
      gridVal = { periodId: val.periodId, periodName: val.periodName, endDate: val.endDate };
      periodHash[val.periodId] = gridVal;
      gridData.push(gridVal);
    }
    gridVal['_' + val.nodeId + '_' + val.measureId] = amount;
  };

  const _updatePercentages = (chartData, total) => {
    for (let i = 0; i < chartData.length; i++) {
      let data = chartData[i];
      data.percentage = data.amount / total;
      if (setup.percentages) data.value = data.percentage;
    }
  };

  const _generateCircleData = (widgetInstance, chartData, selectedPeriod, setSeries, setup) => {
    let data = [];
    let gridData = [];

    if (!chartData) return chartData;

    let periodHash = {};

    let series = setup.series[0];

    let total = 0;

    for (let i = 0; i < chartData.length; i++) {
      let val = chartData[i];
      let node = widgetInstance.nodes.find(function (item) {
        return item.id === val.nodeId;
      });
      if (val.periodId === selectedPeriod[periodIdField] && val.measureId.toString() === series.measureId.toString() && node) {
        let amount = val.amount / (series.amountsIn || 1);
        data.push({
          category: node.name, // val.nodeId,
          value: amount,
          amount: amount,
          percentage: setup.percentages,
          lookupRef: { nodeId: node.id, measureId: val.measureId, scale: setup.series[0].scale },
        });

        total += amount;

        _registerGridRecord(val, periodHash, amount, gridData);
      }
    }

    _updatePercentages(chartData, total);

    setGridData(gridData);

    setSeries([
      {
        type: setup.type,
        data: data,
        labels: {
          visible: setup.seriesLabels,
          background: 'transparent',
          position: 'outsideEnd',
          callbackTemplate: (e) => {
            return (
              e.category +
              ': ' +
              formatNumber(
                e.dataItem.percentage ? e.percentage : e.value,
                e.dataItem.percentage ? `p${e.dataItem.lookupRef.scale}` : `n${e.dataItem.lookupRef.scale}`
              )
            );
          },
        },
        tooltip: {
          visible: !setup.seriesLabels,
          callbackTemplate: (e) => {
            if (e.point) {
              return (
                e.point.dataItem &&
                e.point.category + ': ' + formatNumber(e.point.value, e.point.dataItem.percentage ? `p` : `n${e.point.dataItem.lookupRef.scale}`)
              );
            }
          },
        },
        legend: {
          visible: setup.legend !== 'none',
          position: setup.legend,
        },
      },
    ]);
  };

  _generateCircleData(widgetInstance, chartData, selectedPeriod, setSeries, setup);
};
export default generateCircleCharts;
